import { Component } from '@theme/component';

class WinePurchaseExtras extends Component {
  #observer = new MutationObserver(() => this.#updateLabel());

  connectedCallback() {
    super.connectedCallback();
    this.#connect();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#connect();
  }

  disconnectedCallback() {
    this.#observer.disconnect();
    super.disconnectedCallback();
  }

  #connect() {
    this.#observer.disconnect();
    const panel = this.closest('.group-block-content');
    if (!panel) return;
    this.#observer.observe(panel, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'aria-label'],
    });
    this.#updateLabel();
  }

  #updateLabel() {
    const panel = this.closest('.group-block-content');
    const button = panel?.querySelector('#wishlisthero-product-page-button-container button');
    if (!(button instanceof HTMLButtonElement)) return;

    const saved = button.classList.contains('wishlisthero-product-in-wishlist');
    const label = saved ? this.dataset.savedLabel : this.dataset.saveLabel;
    if (!label) return;

    const span = button.querySelector('span');
    const text = span && Array.from(span.childNodes).find(
      node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
    );
    if (text && text.textContent.trim() !== label) text.textContent = ' ' + label;

    const accessibleLabel = saved ? label + '. ' + this.dataset.removeLabel : label;
    if (button.getAttribute('aria-label') !== accessibleLabel) {
      button.setAttribute('aria-label', accessibleLabel);
    }
    button.setAttribute('aria-pressed', String(saved));
    button.title = saved ? this.dataset.removeLabel : label;
  }
}

if (!customElements.get('st-wine-purchase-extras')) {
  customElements.define('st-wine-purchase-extras', WinePurchaseExtras);
}
